import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userApiService from '../services/oraganisation-api.service';

export const fetchOrganizationDetails = createAsyncThunk(
  'auth/fetchOrganizationDetails',
  async (_, { rejectWithValue }) => {
    try {
      return await userApiService.getOrgDetails();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: null,
    isAuthenticated: null,
    userAttributes: null,
    organization: null,
    organizationLoading: false,
    organizationError: null,
  },
  reducers: {
    login(state, action) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.userAttributes = action.payload.userAttributes;
      state.organization = action.payload.organization;
      state.organizationLoading = false;
      state.organizationError = action.payload.organizationError ?? null;
    },
    initializeAuth(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.userAttributes = null;
      state.organization = null;
      state.organizationError = null;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.userAttributes = null;
      state.organization = null;
      state.organizationError = null;
    },
    refreshUserAttributes(state, action) {
      state.userAttributes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationDetails.pending, (state) => {
        state.organizationLoading = true;
        state.organizationError = null;
      })
      .addCase(fetchOrganizationDetails.fulfilled, (state, action) => {
        state.organizationLoading = false;
        state.organization = action.payload;
        state.organizationError = null;
      })
      .addCase(fetchOrganizationDetails.rejected, (state, action) => {
        state.organizationLoading = false;
        state.organizationError = action.payload;
      });
  },
});

export const { login, logout, initializeAuth, refreshUserAttributes } =
  authSlice.actions;
export default authSlice.reducer;
